var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.18,191.6c-7.88-28.38-60.41,2.49-60.41,2.49l13.75-24.94a55.07,55.07,0,0,0,4.35-7.89c6.91-15.44,6.82-32,0-46.34C660,106.19,654.25,93.71,638.52,80,608.75,54.15,508.94,36.45,480,40.38s26.27,16.09,26.27,16.09l-4.37,0c-84.15-8.92-168.82-10.07-252.83-8.33-21.07.43-42.2,1.13-62.83,4.68-5.93,1-12.31,2.59-15.85,7.38C154.75,81.43,218.9,83.5,229,83.09c-44.07,5.73-93,7.49-134,24.52-5.71,2.37-11.38,5.19-15.69,9.58s-7.11,10.64-6.14,16.91C76,152.29,101,157.69,115.24,161.73c0,0-81.72,54.34-72.09,81.92a96.66,96.66,0,0,0,20.91,35.22A135.83,135.83,0,0,0,48,303.73c-2.61,5.34-6,12.65-3.11,18.8,14.88,31.32,240.61,138.86,421.49,108.16,48.05-8.15,95.91-21.63,138-45.47,41.92-23.73,84.64-62.93,95.2-112.35.35-1.63.6-3.21.78-4.75C707,245.35,710.78,215.34,704.18,191.6Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.18,191.6c-7.88-28.38-60.41,2.49-60.41,2.49l13.75-24.94a55.07,55.07,0,0,0,4.35-7.89c6.91-15.44,6.82-32,0-46.34C660,106.19,654.25,93.71,638.52,80,608.75,54.15,508.94,36.45,480,40.38s26.27,16.09,26.27,16.09l-4.37,0c-84.15-8.92-168.82-10.07-252.83-8.33-21.07.43-42.2,1.13-62.83,4.68-5.93,1-12.31,2.59-15.85,7.38C154.75,81.43,218.9,83.5,229,83.09c-44.07,5.73-93,7.49-134,24.52-5.71,2.37-11.38,5.19-15.69,9.58s-6,10.56-6.14,16.91c-.4,16.77,26.56,23,42.11,27.63,0,0-81.72,54.34-72.09,81.92a96.66,96.66,0,0,0,20.91,35.22A135.83,135.83,0,0,0,48,303.73c-2.61,5.34-6,12.65-3.11,18.8,14.88,31.32,240.61,138.86,421.49,108.16,48.05-8.15,95.91-21.63,138-45.47,41.92-23.73,84.64-62.93,95.2-112.35.35-1.63.6-3.21.78-4.75C707,245.35,710.78,215.34,704.18,191.6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.46,161.92l-.49-.45c-.06-.05-6-5.42-10.79-4.47s-5.71,3.64-5.75,3.76l-.95-.32c0-.14,1.18-3.35,6.5-4.42,4.51-.9,9.6,3,11.18,4.29,1-1.91,4.56-7.91,8.25-8.37,4.25-.53,8.85,3,9,3.16l-.61.79c-.05,0-4.49-3.44-8.31-3s-7.74,8.32-7.78,8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.19,181.31l-.49-.45c-.06-.05-6-5.43-10.79-4.47s-5.7,3.64-5.74,3.75l-.95-.32c0-.13,1.17-3.34,6.5-4.41,4.5-.9,9.59,3,11.17,4.29,1-1.91,4.56-7.92,8.25-8.38,4.26-.52,8.85,3,9,3.17l-.61.79s-4.48-3.45-8.3-3-7.74,8.32-7.78,8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.52,181.31l-.49-.45s-4.51-4.09-8.11-3.37-4.25,2.69-4.28,2.78l-.95-.32c0-.11.92-2.62,5-3.44,3.36-.67,7.16,2.1,8.49,3.2.87-1.59,3.52-6,6.3-6.32,3.28-.4,6.82,2.32,7,2.44l-.61.79s-3.36-2.6-6.24-2.23c-2.32.29-5,4.66-5.82,6.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.67,201.72l-.49-.45s-2.91-2.62-5.17-2.17-2.66,1.66-2.68,1.71l-1-.32c0-.07.64-1.81,3.44-2.37,2.15-.43,4.54,1.2,5.55,2,.67-1.2,2.34-3.82,4.16-4,2.2-.29,4.6,1.55,4.7,1.63l-.61.79s-2.18-1.66-4-1.43c-1.45.18-3.15,3-3.69,4.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.17,178.57H212.43l.54-.78c.22-.32,5.39-7.67,11.9-7.08,1.07.1,2.09.21,3,.32,4.61.51,7.94.88,9.67-1.28a6.31,6.31,0,0,0,1-3.34c.29-2.33.61-5,4.91-6.54,2.55-.93,5.2-.22,7.76.47,2.74.74,5.33,1.44,7.61.14s2.69-3.91,3.11-6.67a14,14,0,0,1,1.61-5.45c2.75-4.27,8.75-6.55,13.05-6.55h.08c2.9,0,5.5,1.35,8,2.62,2.86,1.46,5.57,2.84,8.58,2.32a6,6,0,0,0,4.16-3.69,35,35,0,0,0,2.05-7.16c.88-4.21,1.71-8.19,5.72-11.88a30.32,30.32,0,0,1,16.42-7.29c24.56-3.48,51.69,14.79,56.94,38.35h0c0,.19,1.12,4.76,5.23,4.76a15.53,15.53,0,0,0,4.18-1c5.08-1.68,12.75-4.23,18.55,4.7,7.39,11.37,5.92,14.51,5.73,14.83Zm-197.77-1H411.52c.15-.89.15-4.42-5.77-13.53-5.38-8.27-12.33-6-17.4-4.29a16.21,16.21,0,0,1-4.49,1.09c-4.92,0-6.19-5.48-6.21-5.54h0c-5.14-23.09-31.74-41-55.82-37.58a29.35,29.35,0,0,0-15.89,7c-3.76,3.47-4.56,7.29-5.41,11.34a35.83,35.83,0,0,1-2.11,7.36,6.89,6.89,0,0,1-4.91,4.28c-3.34.57-6.32-1-9.21-2.42-2.4-1.22-4.89-2.49-7.55-2.51h-.08c-4.09,0-9.74,2.27-12.21,6.09A13.23,13.23,0,0,0,263,154c-.44,2.87-.9,5.84-3.61,7.38s-5.55.73-8.36,0c-2.41-.65-4.91-1.32-7.16-.5-3.72,1.35-4,3.47-4.25,5.72a7.25,7.25,0,0,1-1.25,3.85c-2.07,2.59-5.82,2.17-10.56,1.64-1-.11-2-.22-3-.31C220.05,171.27,215.9,175.72,214.4,177.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.25,126.83H366.37l.54-.79c.09-.13,2.26-3.22,5-3l1.23.13c1.93.22,3.05.3,3.61-.4a2.2,2.2,0,0,0,.35-1.19,3,3,0,0,1,2.17-2.87,5.37,5.37,0,0,1,3.29.18,3.77,3.77,0,0,0,2.83.09c.79-.46.93-1.39,1.1-2.46a5.7,5.7,0,0,1,.69-2.31,7,7,0,0,1,5.48-2.76h0a7.49,7.49,0,0,1,3.34,1.08,5.33,5.33,0,0,0,3.26.9,2.13,2.13,0,0,0,1.45-1.3,14.3,14.3,0,0,0,.8-2.82,8.19,8.19,0,0,1,2.39-4.92,12.47,12.47,0,0,1,6.75-3c10-1.42,21,6,23.17,15.62h0c0,.07.41,1.67,1.81,1.67a6.14,6.14,0,0,0,1.58-.4c2.13-.7,5.33-1.77,7.79,2,2.93,4.51,2.5,5.94,2.3,6.27Zm-78.86-1h78.15c0-.53-.33-2-2.29-5s-4.58-2.28-6.63-1.6a6.68,6.68,0,0,1-1.9.45,3,3,0,0,1-2.79-2.47c-2-9.11-12.55-16.18-22.05-14.83a11.54,11.54,0,0,0-6.22,2.75,7.14,7.14,0,0,0-2.08,4.39,15.17,15.17,0,0,1-.86,3,3.08,3.08,0,0,1-2.2,1.89,6.12,6.12,0,0,1-3.88-1,6.83,6.83,0,0,0-2.9-1,5.89,5.89,0,0,0-4.67,2.3,5,5,0,0,0-.54,1.92c-.18,1.16-.39,2.48-1.6,3.17s-2.39.34-3.58,0a4.61,4.61,0,0,0-2.69-.21,2,2,0,0,0-1.51,2,3.09,3.09,0,0,1-.57,1.69c-.93,1.17-2.51,1-4.5.77l-1.21-.12C370.44,123.93,369.13,125,368.39,125.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.15,243.28H536.27l.55-.78c.09-.13,2.26-3.23,5-3l1.23.13c1.93.21,3,.3,3.61-.4a2.29,2.29,0,0,0,.36-1.19,3,3,0,0,1,2.16-2.87,5.29,5.29,0,0,1,3.29.18,3.72,3.72,0,0,0,2.83.08c.79-.45.93-1.38,1.1-2.46a5.81,5.81,0,0,1,.69-2.3,7,7,0,0,1,5.52-2.76A7.57,7.57,0,0,1,566,229a5.38,5.38,0,0,0,3.26.9,2.12,2.12,0,0,0,1.44-1.3,13.82,13.82,0,0,0,.8-2.82,8.19,8.19,0,0,1,2.39-4.92,12.4,12.4,0,0,1,6.75-3c10-1.42,21,6,23.17,15.61,0,.08.41,1.68,1.81,1.68a6.48,6.48,0,0,0,1.58-.4c2.13-.71,5.34-1.77,7.79,2,2.93,4.5,2.5,5.94,2.31,6.27Zm-78.86-1h78.15c0-.52-.33-1.95-2.29-5s-4.58-2.28-6.63-1.6a6.68,6.68,0,0,1-1.9.45,3,3,0,0,1-2.78-2.46h0c-2-9.12-12.54-16.2-22.06-14.84a11.46,11.46,0,0,0-6.22,2.74,7.24,7.24,0,0,0-2.08,4.39,15,15,0,0,1-.86,3,3.08,3.08,0,0,1-2.19,1.9,6.27,6.27,0,0,1-3.89-1,6.53,6.53,0,0,0-2.9-1h0a6,6,0,0,0-4.64,2.3,5,5,0,0,0-.54,1.92c-.18,1.16-.39,2.48-1.59,3.17s-2.4.34-3.59,0a4.52,4.52,0,0,0-2.69-.21,2,2,0,0,0-1.51,2.05,3.21,3.21,0,0,1-.56,1.69c-.94,1.17-2.52,1-4.51.77-.38,0-.79-.09-1.21-.12C540.34,240.39,539,241.49,538.29,242.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.6,237.76H373.38l.55-.78c.13-.2,3.36-4.81,7.48-4.43l1.88.19c2.77.31,4.78.54,5.77-.71a3.78,3.78,0,0,0,.6-2,4.26,4.26,0,0,1,3.14-4.17c1.62-.59,3.28-.15,4.88.28s3.2.87,4.53.1,1.57-2.31,1.82-3.95a8.78,8.78,0,0,1,1-3.43c1.72-2.68,5.49-4.11,8.18-4.11h0a11.5,11.5,0,0,1,5,1.63c1.74.88,3.37,1.71,5.16,1.41a3.5,3.5,0,0,0,2.41-2.16,21.85,21.85,0,0,0,1.25-4.36c.55-2.62,1.06-5.09,3.57-7.4a18.84,18.84,0,0,1,10.2-4.53c15.17-2.15,31.95,9.14,35.2,23.71h0c.06.28.72,2.78,3,2.78a9.38,9.38,0,0,0,2.51-.63c3.18-1.05,8-2.65,11.62,3,4.52,6.94,3.73,9,3.53,9.32Zm-121.23-1H495.93c0-.67-.2-2.87-3.55-8-3.22-5-7.24-3.63-10.46-2.56a10.2,10.2,0,0,1-2.83.68c-2.49,0-3.69-2.23-4-3.55h0c-3.14-14.09-19.38-25-34.08-22.94a17.78,17.78,0,0,0-9.66,4.28c-2.27,2.08-2.74,4.3-3.27,6.86a22.45,22.45,0,0,1-1.31,4.56,4.42,4.42,0,0,1-3.16,2.74c-2.12.36-4-.58-5.78-1.5a10.54,10.54,0,0,0-4.56-1.52c-2.47,0-5.89,1.34-7.38,3.65a7.81,7.81,0,0,0-.87,3c-.28,1.81-.57,3.68-2.31,4.67s-3.52.48-5.29,0c-1.52-.41-2.95-.8-4.28-.31-2.18.79-2.32,2-2.49,3.35a4.54,4.54,0,0,1-.81,2.47c-1.34,1.67-3.69,1.41-6.66,1.08l-1.86-.2C378.74,233.3,376.44,235.53,375.37,236.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.27,390.9s-7.29-7.55-5.25-7.33,5.88,5.88,5.88,5.88.05-12.45,1.87-9.73-.41,9.78-.41,9.78,5.2-8.11,5.19-6.79c0,4.1-4,7.31-4,7.31s8.33-6.17,7-3.67-6.69,4.87-6.69,4.87,9.6-1.94,6.19-.57-6.65,2.3-6.65,2.3h-2.66s-9.06-4.55-5.65-3.87A16.85,16.85,0,0,1,504.27,390.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.56,367.26s-5.68-5.88-4.08-5.7,4.57,4.57,4.57,4.57,0-9.69,1.46-7.57-.33,7.61-.33,7.61,4.05-6.31,4-5.28c0,3.19-3.12,5.69-3.12,5.69s6.48-4.81,5.42-2.86-5.2,3.79-5.2,3.79,7.47-1.51,4.81-.45-5.18,1.79-5.18,1.79h-2.06s-7.06-3.54-4.4-3A13.31,13.31,0,0,1,600.56,367.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690,346.17s-5.67-5.88-4.08-5.7,4.57,4.57,4.57,4.57,0-9.69,1.46-7.57-.32,7.61-.32,7.61,4-6.31,4-5.28c0,3.19-3.12,5.69-3.12,5.69s6.48-4.8,5.42-2.86-5.21,3.79-5.21,3.79,7.47-1.51,4.82-.45-5.18,1.79-5.18,1.79h-2.07s-7-3.54-4.4-3A13.17,13.17,0,0,1,690,346.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576,394.34s-6.78-7-4.87-6.81,5.46,5.46,5.46,5.46,0-11.57,1.74-9S578,393,578,393s4.84-7.54,4.83-6.31c0,3.81-3.73,6.79-3.73,6.79s7.74-5.73,6.47-3.41-6.21,4.53-6.21,4.53,8.92-1.8,5.75-.53-6.19,2.13-6.19,2.13h-2.46s-8.43-4.22-5.26-3.59A15.93,15.93,0,0,1,576,394.34Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.52 364.21 381.87 297.33 368.68 307.88 302.82 208.73 245.56 221.49 228.4 189.44 211.75 188.56 180.4 126.72 133.52 169.5 110.81 161.39 28.22 245.59 27.51 244.89 110.54 160.23 133.29 168.36 180.7 125.1 212.38 187.59 229.01 188.47 246.08 220.35 303.28 207.61 303.47 207.89 368.91 306.42 381.98 295.96 442.27 363.54 441.52 364.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.49,
    y: 368.24,
    width: 1,
    height: 9.45,
    transform: "translate(-134.08 394.16) rotate(-41.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.04,
    y: 229.31,
    width: 5.14,
    height: 1,
    transform: "translate(-52.75 63.68) rotate(-15.18)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.22,
    y: 223.74,
    width: 25.93,
    height: 1,
    transform: "translate(-50.57 68.87) rotate(-15.18)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.68 192.35 150.85 191.79 164.76 171.26 163.82 164.2 163.88 164.06 179.97 131.41 180.87 131.85 164.85 164.37 165.8 171.5 151.68 192.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.03,
    y: 197.63,
    width: 6.27,
    height: 1,
    transform: "translate(-99.4 208.94) rotate(-55.91)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.14,
    y: 227.87,
    width: 38.3,
    height: 1,
    transform: "translate(-138.14 183.13) rotate(-53.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.15 210.42 125.34 209.83 128.35 205.75 129.74 187.69 117.08 177.37 111.35 164.49 112.26 164.08 117.89 176.75 130.78 187.25 129.33 206.11 126.15 210.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.75 201.04 212.17 193.41 213.03 192.89 216.97 199.46 228.36 188.59 229.05 189.31 216.75 201.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.72 361 447.07 360.24 464.51 345.29 498.93 352.67 552.36 277.87 552.71 277.99 586.86 289.38 614.87 249.84 615.28 250.12 707.3 315.03 706.72 315.85 615.11 251.23 587.25 290.56 552.74 279.06 499.37 353.79 464.78 346.38 447.72 361",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.4 299.32 590.95 293.44 591.35 292.52 603.7 297.92 614.5 250.42 615.48 250.64 604.4 299.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.17 360.47 507.2 357.18 507.37 356.19 525.5 359.34 552.37 281.13 553.32 281.45 526.17 360.47",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trees-2--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.6,275.67a43.21,43.21,0,0,0-43.36,43.06,42.74,42.74,0,0,0,11,28.7,33.11,33.11,0,0,1,15.19,1.39,41.56,41.56,0,0,1,14.74,8.61h3.89a41.65,41.65,0,0,1,14.75-8.61,32.88,32.88,0,0,1,16-1.26A42.75,42.75,0,0,0,595,318.73,43.22,43.22,0,0,0,551.6,275.67Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.78,336q-2,1-4,2a39.3,39.3,0,0,0-3.79,2.34c-.45.31-.89.64-1.34,1l7.11-13.23-9.75,15.26c-1,.8-2,1.61-2.91,2.44q-2.35,2-4.6,4.2l-.5-14.35,10.2-15.53L552,333.45l-.45-12.84L550.79,335h0l-.73,14.4c-1.31-1.23-2.63-2.43-4-3.61-1.07-.93-2.16-1.85-3.27-2.73l-9.22-15.75,6.77,13.89c-.39-.28-.77-.57-1.17-.84a39.3,39.3,0,0,0-3.79-2.34c-1.3-.69-2.63-1.36-4-2a82.23,82.23,0,0,0-8.2-3.47,80.82,80.82,0,0,1,7.9,4q1.92,1.08,3.78,2.22a36.51,36.51,0,0,1,3.51,2.5,75.28,75.28,0,0,1,6.37,5.72c1.76,1.75,3.48,3.57,5.12,5.4L549,370.61h4.27l-.61-17.54c1.83-2.1,3.78-4.16,5.78-6.15a75.28,75.28,0,0,1,6.37-5.72,36.51,36.51,0,0,1,3.51-2.5q1.86-1.14,3.78-2.22a81,81,0,0,1,7.91-4A81.41,81.41,0,0,0,571.78,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,334.76c0,12.37-6.94,13.3-15.5,13.3s-15.5-.93-15.5-13.3,6.94-38.24,15.5-38.24S218.71,322.38,218.71,334.76Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.45 340.37 205.89 340.55 212.56 336.05 207.8 338.46 208.45 336.57 206.27 339.23 203.71 340.52 203.51 331.64 204.87 328.35 203.48 330.2 203.36 325.05 207.61 319.38 203.33 323.76 203.07 312.42 202.84 319.68 200.12 316.64 202.8 321.07 202.44 332.57 200.06 331.02 197.9 327.19 198.77 330.17 194.53 327.4 202.39 334.18 201.2 371.91 204.43 371.91 203.75 341.99 204.5 341.49 208.45 340.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.52,292.15c0,24.17-13.56,26-30.28,26s-30.28-1.83-30.28-26,13.55-74.72,30.28-74.72S635.52,268,635.52,292.15Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.52,292.15c0,24.17-13.56,26-30.28,26s-30.28-1.83-30.28-26,13.55-74.72,30.28-74.72S635.52,268,635.52,292.15Z",
    style: {
      fill: "#fff",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.48 303.12 610.47 303.46 623.51 294.67 614.2 299.38 615.48 295.7 611.22 300.88 606.22 303.41 605.82 286.05 608.47 279.62 605.76 283.24 605.53 273.17 613.83 262.11 605.47 270.66 604.96 248.5 604.52 262.69 599.19 256.75 604.43 265.41 603.72 287.87 599.09 284.84 594.87 277.36 596.56 283.19 588.27 277.77 603.62 291.01 601.3 364.74 607.62 364.74 606.28 306.28 607.75 305.3 615.48 303.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.34,301.66c0,12.38-6.94,13.31-15.5,13.31s-15.5-.93-15.5-13.31,6.94-38.23,15.5-38.23S700.34,289.29,700.34,301.66Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.34,301.66c0,12.38-6.94,13.31-15.5,13.31s-15.5-.93-15.5-13.31,6.94-38.23,15.5-38.23S700.34,289.29,700.34,301.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "690.08 307.28 687.52 307.45 694.19 302.95 689.42 305.36 690.08 303.48 687.9 306.13 685.34 307.43 685.14 298.54 686.49 295.25 685.11 297.1 684.99 291.95 689.24 286.29 684.96 290.67 684.7 279.33 684.47 286.58 681.75 283.55 684.43 287.98 684.06 299.48 681.69 297.92 679.53 294.09 680.4 297.08 676.16 294.3 684.01 301.08 682.82 338.81 686.06 338.81 685.38 308.9 686.12 308.39 690.08 307.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,291.2c0,12.37-6.94,13.31-15.5,13.31s-15.5-.94-15.5-13.31S44.61,253,53.17,253,68.67,278.83,68.67,291.2Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,291.2c0,12.37-6.94,13.31-15.5,13.31s-15.5-.94-15.5-13.31S44.61,253,53.17,253,68.67,278.83,68.67,291.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.41 296.81 55.85 296.99 62.52 292.49 57.75 294.9 58.41 293.02 56.23 295.67 53.67 296.96 53.47 288.08 54.82 284.79 53.44 286.64 53.32 281.49 57.56 275.83 53.29 280.2 53.03 268.87 52.8 276.12 50.08 273.08 52.76 277.52 52.4 289.01 50.02 287.46 47.86 283.63 48.73 286.62 44.49 283.84 52.34 290.62 51.15 328.35 54.39 328.35 53.71 298.43 54.45 297.93 58.41 296.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,263.14A43.21,43.21,0,0,0,102.1,306.2a42.77,42.77,0,0,0,11,28.71,33.07,33.07,0,0,1,15.19,1.38,41.56,41.56,0,0,1,14.74,8.61H147a41.65,41.65,0,0,1,14.75-8.61,33.13,33.13,0,0,1,16-1.26,42.74,42.74,0,0,0,11.15-28.83A43.22,43.22,0,0,0,145.46,263.14Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,263.14A43.21,43.21,0,0,0,102.1,306.2a42.77,42.77,0,0,0,11,28.71,33.07,33.07,0,0,1,15.19,1.38,41.56,41.56,0,0,1,14.74,8.61H147a41.65,41.65,0,0,1,14.75-8.61,33.13,33.13,0,0,1,16-1.26,42.74,42.74,0,0,0,11.15-28.83A43.22,43.22,0,0,0,145.46,263.14Z",
    style: {
      fill: "#fff",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,323.48q-2,1-4,2a37.33,37.33,0,0,0-3.79,2.33l-1.34,1,7.11-13.24-9.75,15.27q-1.49,1.19-2.91,2.43c-1.57,1.37-3.1,2.76-4.6,4.2l-.5-14.35,10.2-15.53-10.27,13.36-.45-12.85-.73,14.37h0l-.73,14.41c-1.31-1.24-2.63-2.44-4-3.62q-1.6-1.39-3.27-2.73l-9.22-15.75,6.77,13.9c-.39-.29-.77-.57-1.17-.85a37.33,37.33,0,0,0-3.79-2.33c-1.3-.7-2.63-1.37-4-2a82.23,82.23,0,0,0-8.2-3.47A78.57,78.57,0,0,1,125,324q1.92,1.08,3.78,2.23a36.42,36.42,0,0,1,3.51,2.49,77,77,0,0,1,6.37,5.72c1.76,1.75,3.48,3.57,5.12,5.41l-.93,18.28h4.27l-.61-17.54c1.83-2.1,3.78-4.16,5.78-6.15a77,77,0,0,1,6.37-5.72,36.42,36.42,0,0,1,3.51-2.49Q164,325,165.94,324a78.73,78.73,0,0,1,7.91-3.94A81.41,81.41,0,0,0,165.64,323.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.84,391.65V352H214.19v-25.4l44.3-105h37.79V327.2h16.37V352H296.28v39.68Zm-26-64.45h26V255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.53,391.74q-15.33,0-25.4-6.3A39.14,39.14,0,0,1,333,368.12q-5-11-5-25.5V266.41q0-14.9,4.82-26.13a37.69,37.69,0,0,1,14.91-17.53q10.08-6.3,25.82-6.3,15.54,0,25.51,6.3a38,38,0,0,1,14.8,17.53q4.82,11.22,4.82,26.13v76.21q0,14.47-5,25.5a39.14,39.14,0,0,1-15.12,17.32Q388.43,391.74,373.53,391.74Zm0-28.55q5.67,0,8.19-3.57a20.6,20.6,0,0,0,3.36-8.5,55.72,55.72,0,0,0,.84-9.13V267a67,67,0,0,0-.74-9.66,20.4,20.4,0,0,0-3.25-8.71q-2.52-3.66-8.4-3.67t-8.5,3.67a19.64,19.64,0,0,0-3.36,8.71,67,67,0,0,0-.74,9.66V342a54.64,54.64,0,0,0,.84,9.13,19,19,0,0,0,3.57,8.5Q368.07,363.19,373.53,363.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.94,391.65V352H436.3v-25.4l44.29-105h37.79V327.2h16.37V352H518.38v39.68Zm-26-64.45h26V255Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.11,309.64c-65.38,42.86-194.5,72-343.1,72-153.16,0-285.63-31-348.94-76V478h692Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,382.17c-74.05,0-146.07-7.31-208.27-21.14-60.58-13.46-109.32-32.47-141-55l.58-.81c31.53,22.42,80.14,41.37,140.6,54.81C231.09,373.87,303,381.17,377,381.17c134.14,0,257-23.71,328.65-63.42l.49.88C634.36,358.41,511.32,382.17,377,382.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.44,315.61l-.51-.86c3.18-1.87,6.28-3.8,9.21-5.72l.55.83C717.74,311.8,714.63,313.73,711.44,315.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trees-1--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.37,299.65c0,25.28-14.18,27.19-31.66,27.19S615,324.93,615,299.65s14.18-78.12,31.67-78.12S678.37,274.37,678.37,299.65Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "657.41 311.12 652.17 311.48 665.82 302.29 656.07 307.21 657.41 303.37 652.96 308.79 647.73 311.43 647.32 293.27 650.09 286.56 647.25 290.33 647.01 279.81 655.69 268.24 646.95 277.18 646.42 254.01 645.95 268.84 640.39 262.63 645.86 271.69 645.12 295.18 640.28 292.01 635.86 284.19 637.63 290.28 628.97 284.62 645.02 298.46 642.59 375.56 649.2 375.56 647.8 314.43 649.33 313.4 657.41 311.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.57,376.24s-11.68-12.11-8.4-11.75,9.41,9.42,9.41,9.42.09-20,3-15.59-.67,15.68-.67,15.68,8.33-13,8.32-10.88c-.06,6.57-6.43,11.71-6.43,11.71S663.16,364.94,661,369s-10.72,7.8-10.72,7.8,15.39-3.11,9.92-.92-10.67,3.69-10.67,3.69h-4.25s-14.53-7.29-9.06-6.2A26.87,26.87,0,0,1,644.57,376.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,361.2s-10.11-10.47-7.28-10.15,8.15,8.14,8.15,8.14.07-17.26,2.6-13.48-.58,13.55-.58,13.55,7.21-11.24,7.19-9.41c0,5.69-5.55,10.13-5.55,10.13s11.54-8.55,9.65-5.08-9.27,6.74-9.27,6.74,13.31-2.68,8.58-.79S89,364,89,364H85.31s-12.56-6.3-7.84-5.36A23.76,23.76,0,0,1,84.73,361.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.26,285.87c0,25.31-14.19,27.22-31.7,27.22s-31.7-1.91-31.7-27.22,14.2-78.21,31.7-78.21S121.26,260.56,121.26,285.87Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.28 297.35 95.04 297.71 108.69 288.51 98.94 293.44 100.28 289.59 95.82 295.02 90.59 297.66 90.18 279.49 92.95 272.76 90.11 276.54 89.87 266 98.56 254.42 89.81 263.38 89.28 240.18 88.81 255.03 83.24 248.81 88.72 257.88 87.98 281.39 83.13 278.22 78.71 270.39 80.48 276.49 71.8 270.82 87.88 284.68 85.44 361.86 92.06 361.86 90.66 300.67 92.19 299.64 100.28 297.35",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.39,387.51s-10.11-10.47-7.27-10.15,8.15,8.14,8.15,8.14.07-17.26,2.59-13.48-.58,13.55-.58,13.55,7.21-11.24,7.2-9.41c0,5.69-5.56,10.13-5.56,10.13s11.55-8.55,9.66-5.08S200.3,388,200.3,388s13.31-2.68,8.58-.79-9.23,3.19-9.23,3.19H196s-12.57-6.3-7.84-5.36A23.61,23.61,0,0,1,195.39,387.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,410.46s-10.11-10.47-7.27-10.15,8.15,8.14,8.15,8.14.07-17.26,2.59-13.48-.58,13.55-.58,13.55,7.21-11.24,7.2-9.4c-.05,5.68-5.56,10.12-5.56,10.12s11.55-8.55,9.66-5.08S254,410.9,254,410.9s13.31-2.68,8.58-.79-9.23,3.19-9.23,3.19h-3.67s-12.57-6.3-7.84-5.36A23.61,23.61,0,0,1,249,410.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,395.05s-7.29-7.55-5.24-7.32,5.87,5.87,5.87,5.87.06-12.45,1.88-9.72-.42,9.78-.42,9.78,5.2-8.12,5.19-6.79c0,4.1-4,7.3-4,7.3s8.33-6.17,7-3.66-6.69,4.86-6.69,4.86,9.6-1.94,6.18-.57-6.65,2.3-6.65,2.3h-2.65s-9.07-4.55-5.66-3.87A17.18,17.18,0,0,1,392.94,395.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,377s-5.67-5.88-4.08-5.7,4.57,4.57,4.57,4.57,0-9.69,1.46-7.57-.33,7.61-.33,7.61,4-6.31,4-5.28c0,3.19-3.12,5.68-3.12,5.68s6.48-4.8,5.42-2.85-5.2,3.78-5.2,3.78,7.47-1.5,4.81-.44-5.18,1.79-5.18,1.79H676.3s-7.06-3.54-4.4-3A13.13,13.13,0,0,1,676,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9,395.09s-10.11-10.47-7.27-10.15,8.15,8.14,8.15,8.14.07-17.26,2.59-13.48-.57,13.56-.57,13.56,7.21-11.25,7.19-9.41c-.05,5.68-5.55,10.12-5.55,10.12s11.54-8.55,9.65-5.08-9.27,6.74-9.27,6.74,13.3-2.68,8.57-.79-9.22,3.19-9.22,3.19h-3.68s-12.57-6.3-7.84-5.36A23.61,23.61,0,0,1,293.9,395.09Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,388.14s-6.78-7-4.87-6.82,5.46,5.47,5.46,5.47,0-11.58,1.74-9-.39,9.09-.39,9.09,4.84-7.55,4.83-6.31c0,3.81-3.73,6.79-3.73,6.79s7.74-5.74,6.47-3.41-6.21,4.52-6.21,4.52,8.92-1.8,5.75-.53-6.19,2.14-6.19,2.14h-2.46s-8.43-4.23-5.26-3.59A15.61,15.61,0,0,1,221,388.14Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,415.88s-6.78-7-4.87-6.81,5.46,5.46,5.46,5.46.05-11.58,1.74-9-.39,9.09-.39,9.09S143,407,143,408.27c0,3.81-3.73,6.79-3.73,6.79s7.74-5.74,6.48-3.41-6.22,4.52-6.22,4.52,8.92-1.8,5.75-.53-6.19,2.14-6.19,2.14h-2.46s-8.43-4.23-5.26-3.59A15.61,15.61,0,0,1,136.26,415.88Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,417.24s-6.78-7-4.88-6.81,5.47,5.46,5.47,5.46.05-11.58,1.74-9-.39,9.09-.39,9.09,4.84-7.54,4.82-6.31c0,3.81-3.72,6.79-3.72,6.79s7.74-5.74,6.47-3.41-6.22,4.52-6.22,4.52,8.93-1.8,5.76-.53-6.19,2.14-6.19,2.14h-2.47s-8.42-4.23-5.25-3.59A15.61,15.61,0,0,1,363,417.24Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,417.6s-6.77-7-4.87-6.81,5.46,5.47,5.46,5.47.05-11.58,1.74-9-.39,9.08-.39,9.08,4.84-7.54,4.83-6.31c0,3.82-3.73,6.8-3.73,6.8s7.74-5.74,6.48-3.41-6.22,4.52-6.22,4.52,8.92-1.8,5.75-.53-6.19,2.14-6.19,2.14H473.4s-8.43-4.23-5.26-3.6A15.93,15.93,0,0,1,473,417.6Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.47,395.63s-10.32-10.69-7.42-10.37,8.31,8.32,8.31,8.32.08-17.63,2.65-13.76-.59,13.84-.59,13.84,7.37-11.49,7.35-9.61c0,5.8-5.67,10.34-5.67,10.34s11.78-8.73,9.85-5.19-9.46,6.88-9.46,6.88,13.58-2.74,8.75-.81-9.42,3.26-9.42,3.26h-3.75s-12.83-6.44-8-5.47A24.26,24.26,0,0,1,677.47,395.63Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.54,395.63s-10.32-10.69-7.43-10.37,8.32,8.32,8.32,8.32.08-17.63,2.65-13.76-.59,13.84-.59,13.84,7.36-11.49,7.35-9.61c0,5.8-5.67,10.34-5.67,10.34S79,385.66,77,389.2s-9.47,6.88-9.47,6.88,13.59-2.74,8.76-.81-9.42,3.26-9.42,3.26H63.14s-12.83-6.44-8-5.47A24.26,24.26,0,0,1,62.54,395.63Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,380.54s-10.56-18.22-7.55-19.62,9.24,12.45,9.24,12.45-1.21-26.11,1.6-23.7,5.42,20.89,5.42,20.89,5.63-20.09,7.44-15.87-1.45,17-1.45,17,8.07-15.37,8.88-10.35-3.82,13.25-3.82,13.25,10.64-10.64,11.45-6.42-2.81,8.43-2.81,8.43,14.05-7.63,10.64-3.41-8.43,9.64-8.43,9.64,13.45-4.82,11.84-2-7.63,5.82-7.63,5.82,11-2,9.84-.2a16.23,16.23,0,0,1-4,3.59h-50s-13.25-4.79-8-5.19a23,23,0,0,1,10,1.8s-16.27-11-8.64-11.84,13.86,8.83,13.86,8.83-10.84-15.26-7-12.85Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,385.72s-13.64-14.13-9.81-13.7,11,11,11,11,.1-23.29,3.5-18.19S118,383.1,118,383.1s9.73-15.17,9.71-12.69c-.07,7.67-7.5,13.66-7.5,13.66s15.58-11.53,13-6.86-12.51,9.1-12.51,9.1,18-3.62,11.58-1.07-12.45,4.31-12.45,4.31h-5s-17-8.51-10.57-7.23A31.62,31.62,0,0,1,114.13,385.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,390.05H114.8l-.11-.06c-12.74-6.39-12.39-7.4-12.25-7.82.22-.64,1.11-.52,2-.34a39,39,0,0,1,7.4,2.21c-3.84-4.11-9.38-10.45-8.6-12a1,1,0,0,1,1.13-.49c3.22.36,8.38,7.05,10.45,9.93.08-5.48.51-17.14,2.79-17.82.56-.17,1.1.14,1.62.91,2.48,3.72,1.16,11.3.13,15.59,7.12-10.86,8-10.58,8.41-10.47a.69.69,0,0,1,.47.75,17.39,17.39,0,0,1-4,10.15c4.41-3.06,8.6-5.56,9.51-4.76.56.49.1,1.33-.08,1.65-1.66,3.05-6.23,5.93-9.42,7.66,9.59-1.81,9.77-1.23,9.9-.8.18.61-.55.95-1.67,1.4-6.32,2.53-12.43,4.3-12.49,4.32Zm-4.91-1h4.77c.67-.2,6.17-1.83,12-4.12-2.38.27-6.82,1-10.92,1.87l-4.17.84.61.64-3.43-2.14a31.61,31.61,0,0,0-9.61-3.33l-.39-.07A97.33,97.33,0,0,0,115,389.05Zm-10.91-16.54c0,1.28,5.28,7.6,10.36,12.86l2.14,2.22,3.92-1.74c.1,0,9.83-4.4,12.27-8.88a2.36,2.36,0,0,0,.18-.37c-1.46.24-7.43,4.14-12.46,7.87l-.61-.79c.07-.05,6.87-5.63,7.29-12.7-1.47,1.48-5.38,7.1-8.77,12.39l-2,3.18,1.14-3.6c0-.13,4.07-13,.84-17.85-.32-.49-.49-.51-.49-.51-1.09.2-2.05,8.63-2.09,18.42v1.61l-.91-1.33c-2-2.89-7.68-10.45-10.63-10.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2,412.58s-20-34.42-14.27-37.08S566.4,399,566.4,399s-2.28-49.34,3-44.79,10.25,39.48,10.25,39.48,10.63-38,14.05-30S591,395.82,591,395.82s15.26-29.05,16.78-19.56-7.21,25.05-7.21,25.05,20.12-20.12,21.64-12.15-5.32,15.95-5.32,15.95,26.57-14.43,20.12-6.46-15.94,18.23-15.94,18.23,25.43-9.12,22.39-3.8-14.42,11-14.42,11,20.88-3.8,18.6-.38-7.58,6.77-7.58,6.77H545.52s-25.06-9.05-15.19-9.81,19,3.42,19,3.42-30.74-20.88-16.32-22.4,26.19,16.7,26.19,16.7-20.5-28.85-13.28-24.29Z",
    style: {
      fill: "#8854C0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.49,422.38S538.71,395.67,546,396.47s20.77,20.78,20.77,20.78.19-44,6.62-34.38-1.47,34.56-1.47,34.56,18.38-28.68,18.34-24c-.13,14.49-14.16,25.82-14.16,25.82s29.43-21.8,24.61-13S577,423.5,577,423.5s33.93-6.85,21.87-2-23.53,8.14-23.53,8.14H566s-32-16.08-20-13.67S564.49,422.38,564.49,422.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.43,430.11h-9.56l-.11-.05c-10.83-5.44-23.6-12.32-22.93-14.26.23-.67,1.15-.77,3.27-.35A70.1,70.1,0,0,1,562,420.51c-5.91-6.25-19.2-20.83-17.71-23.85.18-.38.63-.8,1.69-.68,6.37.7,17,15.18,20.23,19.69.09-8.22.7-33.34,5-34.62.85-.26,1.71.26,2.57,1.54,5.14,7.73,1.44,24.58-.47,31.72,6.16-9.5,14.94-22.43,16.85-21.86.22.07.58.28.57,1-.08,9-5.51,16.88-9.67,21.59,7.43-5.28,18.49-12.64,20.31-11.06.7.61.19,1.76-.25,2.57-3.6,6.59-14.56,12.79-20.31,15.7,20.68-4,21-2.85,21.17-2.39.19.64-.49,1.13-2.88,2.09-12,4.78-23.47,8.12-23.58,8.15Zm-9.33-1h9.19c1-.28,12-3.53,23.42-8.1a18.68,18.68,0,0,0,1.73-.77c-2.91,0-13.65,1.8-23.33,3.75l-4.46.9,4.16-1.85c.19-.08,18.72-8.39,23.41-17,.59-1.07.46-1.35.46-1.35-1.31-.91-13.65,7-24.34,15l-.61-.79c.14-.11,13.8-11.31,14-25.35-2,1.22-10.32,13.11-17.42,24.18l-2,3.18,1.14-3.6c.08-.25,7.76-24.8,1.53-34.13-.32-.49-.95-1.29-1.44-1.14-3,.9-4.2,22.09-4.26,35.24v1.62l-.9-1.34c-.14-.2-13.49-19.79-20.42-20.56-.18,0-.6-.05-.68.13-1,2.09,10.86,15.84,19.64,24.93l2.81,2.91-3.44-2.14c-.06,0-6.51-4-18.32-6.37a7.28,7.28,0,0,0-2-.22C545,417.88,555.82,423.94,566.1,429.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocks--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.85,381.57s2-1.85,3.79-1.85,7.1,2.57,7.1,2.57,2.14,3.3,2.33,3.5,2.82,1.32,3,1.78.58,2,.58,2H148.33l-3-7.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,390.05H148l-3.39-8.9,3.05-.08c.52-.43,2.33-1.85,4-1.85,1.81,0,6.76,2.36,7.32,2.62l.12.06.08.12c1,1.53,2.13,3.25,2.28,3.43l.72.36c1.62.8,2.22,1.16,2.39,1.56s.57,1.89.61,2.05Zm-16.64-1H164a12.75,12.75,0,0,0-.39-1.29,16,16,0,0,0-1.91-1.06,4.33,4.33,0,0,1-1-.56c-.2-.2-1.51-2.2-2.32-3.46-1.56-.74-5.45-2.46-6.76-2.46-1.54,0-3.44,1.7-3.46,1.72l-.14.12-2,.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,379.72l-.1,1.56s4.18,2.43,4.09,3.31a16.47,16.47,0,0,1-1,2.91l2.14,2.24H145.42l.87-6.71S148.72,379.53,151.64,379.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,380.6s8.17-12.26,10-12.45a9.05,9.05,0,0,1,7.19,3.89,44.89,44.89,0,0,1,2.92,7.78c.1.29.49.49,2.72,4.08s2.14,5.65,2.14,5.65H119.93a19.12,19.12,0,0,1,1.85-5.06,7.26,7.26,0,0,1,3.89-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,390.05h-32.7l.12-.61a19.64,19.64,0,0,1,1.92-5.22,7.46,7.46,0,0,1,4-2.69l.78-1.21c2-2.92,8.45-12.46,10.38-12.67a9.58,9.58,0,0,1,7.69,4.14,38.93,38.93,0,0,1,2.88,7.62l.07.25.19.25c.32.43,1,1.33,2.49,3.73,2.29,3.69,2.22,5.84,2.21,5.93Zm-31.45-1H151a13.1,13.1,0,0,0-2-4.88,43.71,43.71,0,0,0-2.44-3.65,1.77,1.77,0,0,1-.33-.54,2.11,2.11,0,0,1-.09-.29,35.42,35.42,0,0,0-2.79-7.4,8.53,8.53,0,0,0-6.71-3.64c-1,.15-5.73,6.33-9.65,12.22l-1,1.53-.2.05a6.76,6.76,0,0,0-3.59,2.3A16.73,16.73,0,0,0,120.57,389.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.09,389.35s-.87-2.14-1-2.43-.1-3.11-.39-4.28a30,30,0,0,0-2.72-4.77l1.75-5.05-.88-.68,1.46-3.6-.81-.38c-1.92.34-10,12.44-10,12.44l-.88,1.36a7.26,7.26,0,0,0-3.89,2.53,18.06,18.06,0,0,0-1.8,4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.84,384.62a4.57,4.57,0,0,1,2.38-1.16c1.1,0,4.45,1.61,4.45,1.61s1.34,2.07,1.46,2.19,1.77.83,1.89,1.12.37,1.24.37,1.24H463.14l-1.89-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,390.12H462.8l-2.26-5.94,2.11-.06a4.67,4.67,0,0,1,2.57-1.16c1.18,0,4.31,1.49,4.67,1.66l.12.06.08.12c.61.95,1.31,2,1.42,2.13s.18.07.39.18c1.07.54,1.45.77,1.58,1.07a11.72,11.72,0,0,1,.39,1.31Zm-10.54-1h9.25c-.07-.24-.14-.45-.18-.55s-.8-.41-1.11-.57a2.44,2.44,0,0,1-.67-.39,18.78,18.78,0,0,1-1.45-2.15,17.43,17.43,0,0,0-4.11-1.5,4,4,0,0,0-2.05,1l-.13.12-1.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.22,383.46l-.06,1s2.62,1.53,2.56,2.08a10.16,10.16,0,0,1-.61,1.83l1.34,1.4h-7.14l.55-4.21S463.39,383.34,465.22,383.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.48,384s5.13-7.69,6.29-7.81a5.72,5.72,0,0,1,4.51,2.44,28.53,28.53,0,0,1,1.83,4.88c.06.18.3.31,1.71,2.56a7,7,0,0,1,1.34,3.54H445.34a11.74,11.74,0,0,1,1.16-3.17,4.56,4.56,0,0,1,2.44-1.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.63,390.12H444.72l.13-.61a12.44,12.44,0,0,1,1.22-3.33,4.88,4.88,0,0,1,2.55-1.75l.45-.7c2-2.94,5.43-7.9,6.64-8a6.14,6.14,0,0,1,5,2.68,23.86,23.86,0,0,1,1.83,4.83l0,.14h0s0,0,.09.11c.2.27.63.83,1.57,2.35a7.46,7.46,0,0,1,1.42,3.82Zm-19.65-1H464.6a8.69,8.69,0,0,0-1.21-2.78c-.92-1.47-1.33-2-1.52-2.27a1.42,1.42,0,0,1-.24-.39l-.05-.18a22.47,22.47,0,0,0-1.74-4.61,5.17,5.17,0,0,0-4-2.19c-.67.22-3.6,4.11-5.92,7.58l-.65,1-.19.05a4,4,0,0,0-2.14,1.36A9.44,9.44,0,0,0,446,389.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.35,389.5s-.55-1.35-.61-1.53-.06-2-.24-2.68a19.56,19.56,0,0,0-1.71-3l1.1-3.17-.55-.43.91-2.25-.51-.24c-1.2.21-6.26,7.8-6.26,7.8l-.54.85a4.56,4.56,0,0,0-2.44,1.59,11.17,11.17,0,0,0-1.13,3.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.22,414.53s3.86-3.49,7.17-3.49,13.42,4.86,13.42,4.86,4.05,6.23,4.41,6.61,5.33,2.49,5.7,3.36,1.1,3.74,1.1,3.74H629.14l-5.7-14.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.67,430.11H628.8l-6.08-15.94L628,414c.75-.65,4.23-3.5,7.36-3.5,3.39,0,13.22,4.71,13.64,4.91l.12.06.08.12c1.53,2.36,4.07,6.21,4.35,6.53.12.09.86.46,1.51.79,2.75,1.37,4,2.09,4.29,2.73.38.89,1.1,3.69,1.13,3.81Zm-31.18-1h29.89c-.24-.89-.67-2.46-.92-3s-2.66-1.65-3.82-2.23a9.27,9.27,0,0,1-1.77-1c-.37-.37-3.36-5-4.4-6.57-1.17-.55-10.11-4.75-13.08-4.75s-6.8,3.33-6.83,3.36l-.14.13-4.26.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.39,411l-.18,2.94s7.9,4.6,7.72,6.25a31.36,31.36,0,0,1-1.84,5.52l4,4.23h-21.5l1.65-12.69S629.88,410.68,635.39,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,412.7s15.45-23.16,18.94-23.53,10.84,2.57,13.6,7.35,5.33,14.16,5.52,14.71.92.92,5.14,7.72,4.05,10.66,4.05,10.66H575.46s1.29-6.07,3.5-9.56,7.35-4.78,7.35-4.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.68,430.11H574.85l.13-.6c0-.26,1.33-6.2,3.55-9.73,2.07-3.27,6.47-4.66,7.46-4.94l1.56-2.42c1.59-2.39,15.67-23.37,19.3-23.75s11.22,2.63,14.08,7.6c1.65,2.85,3.47,7.66,5.42,14.31.07.26.12.43.14.49a3.18,3.18,0,0,0,.41.6c.61.81,1.87,2.48,4.69,7,4.26,6.86,4.12,10.79,4.12,10.95Zm-59.59-1h58.6c-.11-1.21-.71-4.68-4-9.9a82.69,82.69,0,0,0-4.64-6.93,3.45,3.45,0,0,1-.56-.9l-.15-.52c-1.93-6.57-3.72-11.31-5.32-14.09-2.63-4.56-9.78-7.47-13.12-7.11-2.37.25-12.65,14.43-18.57,23.31l-1.76,2.74-.19.05s-5,1.28-7,4.56A33.84,33.84,0,0,0,576.09,429.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.68,429.24s-1.66-4-1.84-4.59-.18-5.89-.74-8.09-5.14-9-5.14-9l3.31-9.56-1.66-1.29,2.76-6.8-1.54-.71c-3.62.65-18.87,23.51-18.87,23.51l-1.65,2.57s-5.15,1.29-7.35,4.78c-1.89,3-3.1,7.84-3.41,9.19Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.b44680bdad1bf14f5b1ed242f822995f.svg";
export { ForwardRef as ReactComponent };